import { googleApi } from '../config/map';

// Vue 3 Google Maps plugin configuration
export const googleMapsPlugin = {
  install(app, options = {}) {
    
    // Merge default options with user-provided options
    const config = {
      apiKey: googleApi.mapKey,
      libraries: ['places'],
      language: 'en',
      region: 'US',
      mapId: googleApi.mapId,
      fullscreenControl: true,
      ...options
    };

    // Provide the configuration globally
    app.provide('googleMapsApiKey', config.apiKey);
    app.provide('googleMapsConfig', config);

    app.config.globalProperties.$googleMaps = config;
  }
};

export default googleMapsPlugin;
